export default __webpack_public_path__ + "0e50935b878e462141ac619fbef1c184.svg";